export default __webpack_public_path__ + "static/media/img4.59bd54b2.png";